import script from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=ts"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=8cec1626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cec1626"]])

export default __exports__